import React, { Component } from 'react';
import { Modal, Button, Table, Form, Input, Divider, message } from 'antd';
import axios from '../../service/index'

class LabelManagement extends Component {

	constructor(props) {
		super(props)
		this.state = {
			visible: false,
			lableListData: [],
			name: '',
			total: 0,
			searchData: {
				pageNum: 1,
				pageSize: 10,
			},
			labelName: '',
			labelId: null,
			modelTitle: '新建标签',
			columns: [
				{
					title: '标签',
					dataIndex: 'name',
					key: 'name',
					align: 'center'
				},
				{
					title: '创建人',
					dataIndex: 'admin',
					key: 'admin',
					align: 'center'
				},
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							// console.log(record)
							this.setState({
								visible: true,
								labelName: record.name,
								modelTitle: '编辑标签',
								labelId: record.id
							})
						}}>编辑</span>
						<span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '删除标签',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p>标签删除后将不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.delLable(record.id)
								},
							});
						}}>删除</span>
					</div>
				},
			]
		}
	}
	componentDidMount() {
		this.lableList()
	}
	showModal = (e) => {
		this.setState({
			modelTitle: '新增标签',
			visible: true
		})

	}
	handleOk = (e) => {
		this.props.form.validateFields((err, values) => {
			// console.log(err, values)
			if (!err) {
				if(this.state.modelTitle === '新增标签'){
					axios.post('labelController/add',{
						name: values.name
					}).then(res=> {
						if(res.data.code === '200'){
							message.success('添加成功')
							this.lableList()
							this.setState({
								visible: false
							})
						}else {
							message.error(res.data.msg)
						}
					})
				}else {
					axios.post('labelController/update',{
						name: values.name,
						id: this.state.labelId
					}).then(res=> {
						// console.log(res)
						if(res.data.code === '200'){
							message.success('编辑成功')
							this.lableList()
							this.setState({
								visible: false
							})
						}else {
							message.error(res.data.msg)
						}
					})
				}
				
			}
		})
	}
	lableList = () => {
		axios.post('labelController/getList', {
			...this.state.searchData,
			name: this.state.name
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					lableListData: res.data.data.list,
					total: res.data.data.total,
					searchData: {
						pageSize: res.data.data.pageSize,
						pageNum: res.data.data.pageNum,
					}
				})

			}
		})
	}
	delLable(id) {
		axios.get(`labelController/del/${id}`).then( res => {
			if(res.data.code === '200'){
				message.success('删除成功')
				this.lableList()
			}else {
				message.error(res.data.msg)
			}
		})
	}
	handleCancel = () => {
		this.setState({
			visible: false
		})
	};
	render() {
		const { lableListData, modelTitle, columns, visible, labelName, total } = this.state
		const { getFieldDecorator } = this.props.form;
		const pagination ={
			showSizeChanger: true,
			total: total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal:() => `共 ${total} 条`,
			onShowSizeChange: (current,pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.lableList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.lableList(searchData)
			},
		}
		return (
			<div>
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>视频课标签管理</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<div>
						<Input allowClear value={this.state.name} style={{ width: '260px', height: '40px', marginRight: '20px' }} 
						placeholder="请输入标签名称"
						onChange={(e)=>{
							this.setState({
									name: e.target.value
							})
						}}
						></Input>
						<Button className='my-button-primary' type='primary' onClick={() => {
							this.lableList()
						}}>搜索</Button>
						<span className='my-button-txt' style={{marginLeft: '20px'}} type='primary' onClick={() => {
							this.setState({
								name: ''
							},()=>{
								this.lableList()
							})
						}}>重置</span>
					</div>
					<Button className='my-button-primary' type='primary' onClick={(e) => { this.showModal(e) }}>新增标签</Button>
				</div>
				<Table dataSource={lableListData} columns={columns} rowKey={record => record.id} rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')} pagination={pagination}/>
				<Modal
					getContainer={true}
					title={modelTitle}
					okText="确认"
					cancelText="取消"
					visible={visible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
					destroyOnClose
					maskClosable={false}
					
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} onSubmit={this.handleOk}>
						<Form.Item label={"标签名称"}>
							{getFieldDecorator('name', {
								rules: [{ required: true, message: '请输入标签名称!'},{max: 50, message: '最多输入50个字符'}],
								initialValue:modelTitle==='编辑标签'? labelName: ''
							})(
								<Input placeholder='请输入标签名称' />
							)}
						</Form.Item>
					</Form>
				</Modal>
			</div>
		)
	}

};

export default Form.create()(LabelManagement)